import { useContext } from 'react'
import { TransactionsPaginatedContext } from 'contexts/transactionsContext'

export const useTransactionsContext = () => useContext(TransactionsPaginatedContext)
